import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const WHATSAPP_REDIRECT_AFTER_PAINT_MS = 400;

export default function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    if (!redirect) return;

    const timer = setTimeout(() => {
      window.location.href = redirect;
    }, WHATSAPP_REDIRECT_AFTER_PAINT_MS);

    return () => clearTimeout(timer);
  }, [redirect]);

  return (
    <main className="min-h-screen bg-black font-fira flex flex-col items-center justify-center px-4 text-center gap-6">
      <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center">
        <span className="text-3xl" aria-hidden="true">
          ✓
        </span>
      </div>

      <h1 className="font-fira-condensed text-3xl sm:text-4xl font-bold">
        You&apos;re in!
      </h1>

      {redirect ? (
        <>
          <p className="text-secondary text-lg max-w-md">
            Hang tight — opening WhatsApp for you now.
          </p>

          <div
            className="flex flex-col items-center gap-3"
            aria-live="polite"
            aria-label="Redirect in progress"
          >
            <svg
              className="animate-spin h-8 w-8 text-white"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            <p className="text-secondary text-sm">Redirecting…</p>
          </div>

          <a
            href={redirect}
            className="inline-block bg-white text-black font-semibold rounded-full px-8 py-3 text-lg transition-opacity hover:opacity-90"
          >
            Join WhatsApp →
          </a>
        </>
      ) : (
        <p className="text-secondary text-lg max-w-md">
          Thanks for joining. Use the link from your email or message to open the community.
        </p>
      )}
    </main>
  );
}
